import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import {
    getDealerOfferAmountFinancedByVin,
    getDealerOfferFrequencyByVin,
    getDealerOfferPaymentByVin,
    getDealerOfferTypeByVin,
} from "src/store/selectors/dealerOffer";
import { getPaymentFrequencyText, localizeCurrencyWithDecimals } from "src/utils";
import { getAccountDisclaimer } from "src/utils/account";
import "./DealerOfferPayment.scss";
import APR from "Shared/APR";

interface DealerOfferPaymentProps {
    vin: string;
}

const DealerOfferPayment = ({
    amountFinanced,
    disclaimer,
    frequency,
    isPaymentTypeCash,
    payment,
    vin,
}: DealerOfferPaymentProps & ReturnType<typeof mapStateToProps>) => {
    const { t } = useTranslation();

    return (
        <div className="DealerOfferPayment__container">
            {!isPaymentTypeCash && (
                <div className="DealerOfferPayment__paymentContainer">
                    <span className="payment">{payment}</span>
                    <span className="frequency">{` ${frequency}`}</span>
                    <APR vin={vin} />
                </div>
            )}

            {isPaymentTypeCash && (
                <div className="DealerOfferPayment__cashContainer">
                    <span className="copy">{t("CalculatedPayment.cashLabel")}</span>
                    <span className="amountFinanced">{amountFinanced}</span>
                </div>
            )}

            <div className="DealerOfferPayment__disclaimer">{disclaimer}</div>
        </div>
    );
};

const mapStateToProps = (state: ApplicationStore, { vin }: DealerOfferPaymentProps) => {
    return {
        amountFinanced: localizeCurrencyWithDecimals(getDealerOfferAmountFinancedByVin(state, vin)),
        disclaimer: getAccountDisclaimer(state.account)("dealer_offer_disclaimer")("DealerOfferPayment.disclaimer"),
        frequency: getPaymentFrequencyText(getDealerOfferFrequencyByVin(state, vin)!),
        isPaymentTypeCash: getDealerOfferTypeByVin(state, vin) === "cash",
        payment: localizeCurrencyWithDecimals(getDealerOfferPaymentByVin(state, vin)),
        vin,
    };
};
export default connect(mapStateToProps)(DealerOfferPayment);
